import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    Text,
    Input,
    SimpleGrid,
    Box,
    VStack,
    useToast,
    Select,
  } from '@chakra-ui/react';
  import React, { useState } from 'react';
  import { useSelector } from 'react-redux';
  import { RootState } from '../../redux/store';
  
  interface ModalSolicitudProps {
    isOpen: boolean;
    onClose: () => void;
    archivos: {
      recibo?: File;
      fotos?: File[];
    };
    handleArchivoChange: (
      e: React.ChangeEvent<HTMLInputElement>,
      tipo: string,
      multiple?: boolean
    ) => void;
  }
  
  const ModalSolicitud: React.FC<ModalSolicitudProps> = ({
    isOpen,
    onClose,
    archivos,
    handleArchivoChange,
  }) => {
    const user = useSelector((state: RootState) => state.auth.user);
    const [nombre, setNombre] = useState('');
    const [apellidoPaterno, setApellidoPaterno] = useState('');
    const [apellidoMaterno, setApellidoMaterno] = useState('');
    const [ine, setIne] = useState('');
    const [giro, setGiro] = useState('');
    const [tipo, setTipo] = useState('');
    const [movimiento, setMovimiento] = useState('');
    const toast = useToast();
  
    const handleSubmit = async () => {
      if (!user?.id) {
        toast({
          title: 'Error',
          description: 'Usuario no autenticado.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
        return;
      }
  
      const formData = new FormData();
      formData.append('usuarioId', String(user.id));
      formData.append('nombre', nombre);
      formData.append('apellidoPaterno', apellidoPaterno);
      formData.append('apellidoMaterno', apellidoMaterno);
      formData.append('ine', ine);
      formData.append('giro', giro);
      formData.append('tipo', tipo);
      formData.append('movimiento', movimiento);
  
      if (archivos.recibo) {
        formData.append('recibo', archivos.recibo);
      }
  
      if (archivos.fotos && archivos.fotos.length > 0) {
        archivos.fotos.forEach((foto) => {
          formData.append('fotos', foto);
        });
      }
  
      for (let [key, value] of formData.entries()) {
        console.log('FormData:', key, value);
      }
  
      try {
        const response = await fetch('http://52.91.130.91:5000/api/Solicitudes', {
          method: 'POST',
          body: formData,
        });
  
        const result = await response.json();
  
        if (!response.ok) {
          throw new Error(result.message || 'Error al enviar la solicitud');
        }
  
        toast({
          title: 'Solicitud enviada',
          description: 'Se registró la solicitud correctamente.',
          status: 'success',
          duration: 5000,
          isClosable: true,
        });
  
        onClose();
      } catch (error: any) {
        console.error(error);
        toast({
          title: 'Error',
          description: error.message || 'No se pudo enviar la solicitud.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    };
  
    return (
      <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontWeight="bold" color="#A1263D">
            Solicitud de Trámite
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <VStack spacing={6} align="stretch">
              <Text fontWeight="bold" fontSize="lg">
                Datos del Titular
              </Text>
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                <Input
                  placeholder="Nombre"
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                />
                <Input
                  placeholder="Apellido Paterno"
                  value={apellidoPaterno}
                  onChange={(e) => setApellidoPaterno(e.target.value)}
                />
                <Input
                  placeholder="Apellido Materno"
                  value={apellidoMaterno}
                  onChange={(e) => setApellidoMaterno(e.target.value)}
                />
                <Input
                  placeholder="INE (número o archivo)"
                  value={ine}
                  onChange={(e) => setIne(e.target.value)}
                />
              </SimpleGrid>
  
              <Text fontWeight="bold" fontSize="lg">
                Datos del Trámite (Licencia Comercial)
              </Text>
              <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
                <Box>
                  <Text fontSize="sm" mb={1}>Giro</Text>
                  <Select placeholder="Seleccione giro" value={giro} onChange={(e) => setGiro(e.target.value)}>
                    <option>Alimentos</option>
                    <option>Ropa</option>
                    <option>Ferretería</option>
                    <option>Oficina</option>
                    <option>Comercio ambulante</option>
                  </Select>
                </Box>
                <Box>
                  <Text fontSize="sm" mb={1}>Tipo</Text>
                  <Select placeholder="Seleccione tipo" value={tipo} onChange={(e) => setTipo(e.target.value)}>
                    <option>Anual</option>
                    <option>Temporal</option>
                  </Select>
                </Box>
                <Box>
                  <Text fontSize="sm" mb={1}>Movimiento</Text>
                  <Select placeholder="Seleccione movimiento" value={movimiento} onChange={(e) => setMovimiento(e.target.value)}>
                    <option>Nuevo</option>
                    <option>Renovación</option>
                    <option>Cambio de giro</option>
                  </Select>
                </Box>
              </SimpleGrid>
  
              <Text fontWeight="bold" fontSize="lg">
                Documentación Requerida
              </Text>
              <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
                <Box>
                  <Text fontSize="sm" mb={1}>Recibo Predial / Agua</Text>
                  <Input
                    type="file"
                    accept=".pdf,.jpg,.png"
                    onChange={(e) => handleArchivoChange(e, 'recibo')}
                  />
                  {archivos.recibo && (
                    <Text fontSize="xs" mt={1} color="gray.600">
                      Archivo seleccionado: {archivos.recibo.name}
                    </Text>
                  )}
                </Box>
  
                <Box>
                  <Text fontSize="sm" mb={1}>Fotografías del Establecimiento</Text>
                  <Input
                    type="file"
                    multiple
                    accept=".jpg,.png"
                    onChange={(e) => handleArchivoChange(e, 'fotos', true)}
                  />
                  {archivos.fotos && Array.isArray(archivos.fotos) && (
                    <Box mt={1}>
                      {archivos.fotos.map((file, index) => (
                        <Text key={index} fontSize="xs" color="gray.600">
                          {file.name}
                        </Text>
                      ))}
                    </Box>
                  )}
                </Box>
              </SimpleGrid>
            </VStack>
          </ModalBody>
  
          <ModalFooter>
            <Button onClick={onClose} variant="ghost" mr={3}>
              Cancelar
            </Button>
            <Button colorScheme="red" onClick={handleSubmit}>
              Enviar solicitud
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  };
  
  export default ModalSolicitud;
  